module.exports = __webpack_public_path__ + "ng.svg?3c54ce297ccceec2e2c85c0349975fa3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ng.svg
// module id = 1090
// module chunks = 27